import AttachmentId from 'owa-service/lib/contract/AttachmentId';
import { AttachmentPillViewStatus, AttachmentPillData } from '../store/schema/AttachmentPillData';

export default function createAttachmentsPillData(
    attachmentsId: AttachmentId[]
): AttachmentPillData[] {
    const attachmentsPillData: AttachmentPillData[] = attachmentsId.map(attachmentId => {
        return {
            attachmentId: attachmentId,
            attachmentPillViewStatus: AttachmentPillViewStatus.Show,
        };
    });

    return attachmentsPillData;
}
